import React, {useRef} from 'react'
import {Link, useLoaderData, useNavigate} from "react-router";
import CushHead from '../../images/cushhead.png'
import {
  ArrowRightCircleIcon,
  ClockIcon,
  PlayCircleIcon,
  Squares2X2Icon,
  UserCircleIcon
} from "@heroicons/react/24/solid";
import {useAuth} from "../../contexts/auth_context";
import {NewPlayer} from "../models/vlogs/new_player";
import {useToast} from "../ui/toast";

export const Home = props => {
  const nextReplay = useLoaderData()
  const titleCardRef = useRef({})
  const { user } = useAuth()
  const [play, setPlay] = React.useState(nextReplay.showing)
  const {toast} = useToast()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!titleCardRef.current) { return }

    const fontsReady = async () => {
      await document.fonts.ready.then(() => {
        const h1 = document.querySelector('h1')

        if (!h1) { return; }

        const w = h1.clientWidth;
        titleCardRef.current.style.width = h1.clientWidth;
      })
    }

    fontsReady()
  }, [nextReplay])

  const formatNextReplayDate = time => {
    const date = new Date(nextReplay.scheduled_for)
    const month = date.toLocaleString('default', { month: 'long' });
    const day = date.toLocaleString('default', { day: '2-digit' });
    const hour = date.getHours()
    const ampm = (hour >= 12) ? "pm" : "am"
    const timezone =date.toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2]

    return `${month} ${day} - ${hour % 12}${ampm} ${timezone}`
  }

  return <div className="h-full md:w-2/3 mx-auto flex flex-col items-center">
    {nextReplay && <div
      className="flex flex-col md:flex-row gap-10 md:gap-0 items-center py-10 justify-center my-auto h-full">
      <div className="flex justify-center flex-shrink-1 flex-grow-0 min-h-0 min-w-0">
        <img src={CushHead}
             className="max-h-full md:w-3/4 md:min-w-[250px] max-w-[250px] md:max-w-full object-fit-contain"/>
      </div>
      <div className="md:w-fit flex flex-col leading-0 font-[Axiforma_Medium] md:grow-0 gap-10">
        <h1 className="text-5xl md:text-7xl text-[#4F98BD] tracking-wider font-[Axiforma_Heavy] text-center md:text-left w-fit -mb-3">
          CUSHVLOG
        </h1>
        <div ref={titleCardRef} className="flex flex-col gap-10 ">
          {play ?
            <div className="flex flex-col justify-center gap-2">
              <h2 className="text-2xl -mb-1 italic flex items-center gap-1 justify-center">
                <PlayCircleIcon className="size-8 -translate-y-[1.25px]"/>
                <div>Now Playing</div>
              </h2>
              <div className="w-full flex aspect-video relative">
                <button type="button"
                        onClick={() => navigate(`/replays/${nextReplay.id}`)}
                        className="cursor-pointer hover:bg-black/50 w-full h-full z-10 absolute"/>
                <NewPlayer vlog={nextReplay.vlog} autoPlay={true} start={nextReplay.current_millisecond / 1000}/>
              </div>
            </div>:
            <div className="font-[Axiforma_Medium]">
              <div className="w-full justify-center flex flex-col gap-2">
                <h2 className="text-lg -mb-1 italic flex items-center gap-1">
                  <PlayCircleIcon className="size-5 -translate-y-[1.25px]" />
                  <div>Next Replay</div>
                </h2>
                <div className="w-fit">
                  <Link to={`/replays/${nextReplay.id}`}
                        className="text-2xl md:text-3xl whitespace-normal font-[Axiforma_Black] -mb-1">
                    {nextReplay.vlog.title}
                  </Link>
                </div>
                <div className=" italic flex items-center gap-1">
                  <ClockIcon className="size-5 -translate-y-[1.25px]" />
                  <span>{formatNextReplayDate(nextReplay.scheduled_for)}</span>
                </div>
              </div>
            </div>
          }
          {user ?
            <div className="font-[Axiforma_ExtraBold] flex gap-x-8 justify-around items-center">
              <div>
                <Link to="/vlogs" className="flex items-center gap-1">
                  <Squares2X2Icon className="size-5 "/>
                  <span className="mt-1">Vlogs</span>
                </Link>
              </div>
              <div>
                <Link to="/my/user" className="flex items-center gap-1">
                  <UserCircleIcon className="size-5"/>
                  <span className="mt-1">Account</span>
                </Link>
              </div>
            </div> :
            <div className="flex justify-around gap-y-4 items-center flex-wrap font-[Axiforma_ExtraBold]">
              <Link to="/sign-up" className="flex items-center gap-1">
                <span className="mt-1">Sign Up</span>
                <ArrowRightCircleIcon className="size-5" />
              </Link>
              <Link to="/sign-in" className="flex items-center gap-1">
                <span className="mt-1">Sign In</span>
                <UserCircleIcon className="size-5" />
              </Link>
              <Link to="/vlogs" className="flex items-center gap-1">
                <Squares2X2Icon className="size-5 " />
                <span className="mt-1">Vlogs</span>
              </Link>
          </div>}
        </div>
      </div>
    </div>}
  </div>
}
